import { withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Text } from "react-internationalization";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import * as DateUtil from "../../../Utils/DatePicker";
import { Styles } from "../../../assests/styles/DashboradStyles";

import DataTable from "../../../Utils/GenericUI/DataTable";

import { ProspectModalBulkHeader as ProspectSelectedFileHeader } from "../../../Utils/StaticData/DashboardHeader";

import Prospect from "../../prospectManagement/Prospect";
import Demographics from "../../prospectManagement/Demographics";
import { useSelector, useDispatch } from "react-redux";
import {
  ProspectManagementSaveProspect,
  getCampaignList,
  getZipCodes,
  setStateParams,
  updateProspectFilerecords,
  prospectFileData,
  loadProspectFilesData,
  getCityList,
} from "../../../Redux/Actions/webAppActions";

import { handleDateChange } from "../../../Utils/DateFormatter";

import SimpleReactValidator from "simple-react-validator";
import { PROSPECT_MANAGEMENT_INITIAL_STATE } from "../../../components/initialState";
import { connect } from "react-redux";

const SelectedFileTable = (props) => {
  const [SelectedTab, setSelectedTab] = useState("prospect");
  const [bulkmodalrowsPerPage, setbulkmodalrowsPerPage] = React.useState(5);
  const [bulkmodalselectedRowIndex, setbulkmodalselectedRowIndex] =
    React.useState(0);
  const [Data, setData] = useState({ ...PROSPECT_MANAGEMENT_INITIAL_STATE });
  const [validZip, setvalidZip] = useState(true);
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [alertMsg, setalertMsg] = useState("");
  const [severity, setseverity] = useState("");
  const [vertical] = useState("top");
  const [horizontal] = useState("center");
  const [UpdatedList, setUpdatedList] = useState([]);
  const [mandatoryMbi,setmandatoryMbi]=useState("");
  const [filteredCity,setfilteredCity]=useState([]);
  const customerId = useSelector((state1) => state1.login.customerId);
  const prospectRecords = useSelector(
    (state) => state.bulk.prospectBulkfilerecords
  );
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(setStateParams("zipCodes",[]))
  },[])
  useEffect(() => {
    setUpdatedList(prospectRecords);
  }, [prospectRecords]);
  useEffect(()=>{
     let currentzipData={}
      if (props?.zipCodes?.length === 1) {
        currentzipData = {
          county:props?.zipCodes[0]?.countyName,
          state:props?.zipCodes[0]?.stateCd,
          city: props?.zipCodes[0]?.cityName,
        };
        
      }
      if (props?.zipCodes?.length> 1) {
        let selectedzip=[]
        if(Data?.countyCode){
          selectedzip=props?.zipCodes.filter(county=>county.countyCode==Data?.countyCode)[0]
        }
        else{
          if(Data?.county){
            selectedzip=props?.zipCodes.filter(county=>county.countyCode==Data?.county)[0]
          }
        }
       currentzipData = {
         county:selectedzip?.countyName,
         state:selectedzip?.stateCd,
         city:Data?.city,
         countyCode:selectedzip?.countyCode,
       };
      
       
     }
     setData({ ...Data,...currentzipData });
      
  },[Data?.countyCode])
  const prospectTab = async () => {
    setSelectedTab("prospect");
  };
  const demographicsTab = async () => {
    setSelectedTab("demographics");
  };
  const rowSelectbulkModal = async (
    index1,
    selectedData,
    rowsPerPage2,
    type
  ) => {
    //when new row selected initialising data as empty
    setfilteredCity([]);
    setData({ ...PROSPECT_MANAGEMENT_INITIAL_STATE });
    dispatch(setStateParams("zipCodes",[]))
    setSelectedTab("prospect");
    setbulkmodalrowsPerPage(rowsPerPage2);
    setbulkmodalselectedRowIndex(index1);
    let cellPhone = selectedData?.cellPhone ? selectedData?.cellPhone : "";
    let homePhone = selectedData?.homePhone ? selectedData?.homePhone : "";
    if (selectedData?.cellPhone?.length >= 10) {
      cellPhone = formatPhoneNumber(cellPhone);
    }
    if (selectedData?.homePhone?.length >= 10) {
      homePhone = formatPhoneNumber(homePhone);
    }
    // //when new row selected initialising data as empty
    // setData({ ...PROSPECT_MANAGEMENT_INITIAL_STATE });
    //let countyCd={}
    // if(selectedData?.county){
    //   countyCd={
    //     countyCode:selectedData?.county
    //      }
    // }
    
    let SelectedzipData={}
    if(selectedData?.zipCode && selectedData?.zipCode?.trim()?.length===5){
      const res1=await dispatch(getZipCodes(selectedData?.zipCode?.trim()));
       const cityListres=await dispatch(getCityList({
        zipCd:selectedData?.zipCode?.trim(),
      }));
      
      
      if (res1?.data?.length === 1) {
         SelectedzipData = {
          county: res1?.data[0]?.countyName,
          state: res1?.data[0]?.stateCd,
          city: res1?.data[0]?.cityName,
          countyCode:res1?.data[0]?.countyCode,
        };
       
        
      }
      if (res1?.data?.length > 1) {
        let SelectedCountyDetails=[];
        if(selectedData?.countyCode){
          let filteredCity2 = [];
            filteredCity2 = cityListres?.data?.filter(
           (city) => city.countyCode.trim() ===selectedData?.countyCode?.trim()
         );
      
       setfilteredCity(filteredCity2)
          SelectedCountyDetails=res1?.data.filter((county)=>county.countyCode==selectedData?.countyCode)
        }
        else{
          if(selectedData?.county){
            let filteredCity3 = [];
            filteredCity3 =  cityListres?.data?.filter(
           (city) => city.countyCode.trim() ===selectedData?.county?.trim()
         );
         setfilteredCity(filteredCity3)
            SelectedCountyDetails=res1?.data.filter((county)=>county.countyCode==selectedData?.county)
          }
        }
      
        SelectedzipData = {
         county:SelectedCountyDetails[0]?.countyName,
         state: SelectedCountyDetails[0]?.stateCd,
         city:selectedData?.city,
         countyCode:SelectedCountyDetails[0]?.countyCode,
      };
       
     }
      }
    let modifiedData = {
      emailAddress: selectedData?.emailAddr,
      zip: selectedData?.zipCode?.trim(),
      mbi: selectedData?.mbiNumber,
      dob: selectedData?.birthDate,
      gender: selectedData?.sex,
      cellPhone: cellPhone,
      homePhone: homePhone,
      planCampaignName:selectedData?.planCampaignId

    };
    await setData({ ...Data, ...selectedData, ...modifiedData,...SelectedzipData });
  };
  const bulkModalhandleChangeRowsPerPage = async (rowsPerPage3) => {
    await setbulkmodalrowsPerPage(rowsPerPage3);
  };

  const handleChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name.includes("zipPlus4")) {
      value = event.target.value?.trim().replace(new RegExp(/[^\d]/, "ig"), "");
    }

    // if (name.includes("mbi")) {
    //   setData({ ...Data, mbiNumber: value, [name]: value });
    //   return;
    // }
    if (name.includes("mbi")) {
      let valid = false;
      //let count=value.length-1

      if (value.length > 0) {
        if (value !=mandatoryMbi) {
          let temp = "";
          for (let i = 0; i < value.length; i++) {
            if (i === 1 || i === 4 || i === 7 || i === 8) {
              valid = value.charAt(i).match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );

                if (valid === true) {
                  temp = temp + value[i];
                  //mandatoryMbi:this.state.mandatoryMbi+value[count]
                }
              }
            }
            if (i === 0 || i === 3 || i === 6 || i === 9 || i === 10) {
              valid = !isNaN(value[i]);

              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (i === 2 || i === 5) {
              valid = value[i].match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );
              }
              valid = !isNaN(value[i]) || valid;
              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (valid === false || valid === null) {

              setsnackBarOpen(true)
              setalertMsg("Please enter mbi in correct format");
              setseverity("error");

            }
          }
          
            setmandatoryMbi(temp)
          
        }
      } else {
        setmandatoryMbi("")
      }
      setData({ ...Data, mbiNumber: value, [name]: value });
      return;
    }
    if (name.toLowerCase().includes("phone")) {
      value = formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name === "zip") {
      if (value?.length === 5) {
        setfilteredCity([]);
        const response = await dispatch(getZipCodes(value));
        await dispatch(getCityList({
          zipCd: value,
        }));
        if (response?.data === null) {
          setsnackBarOpen(true);
          setalertMsg(response.message);
          setseverity("error");
          setvalidZip(false);
        } else {
          setvalidZip(true);
          await dispatch(setStateParams("zipCodes", response.data));
          if (response?.data?.length === 1) {
            let Selectedzip = {
              county: response?.data[0]?.countyName,
              state: response?.data[0]?.stateCd,
              city: response?.data[0]?.cityName,
              countyCode:response?.data[0]?.countyCode,
              [name]: value,
              zipCode: value,
            };
            await setData({ ...Data, ...Selectedzip });
            return;
          }
          if (response?.data?.length > 1 || response.data.length === 0) {
            await setData({
              ...Data,
              county: "",
              state: "",
              city: "",
              [name]: value,
              zipCode: value,
            });
            return;
          }
        }
      }
    }
    setData({ ...Data, [name]: value });
  };
  const handleMultipleSelectionDropdown = (name) => async (data1) => {
    let multipleValues = [];
    data1.forEach((data2) => {
      multipleValues.push(data2.value);
    });
    if (name == "bestTimeToCall") {
      if (
        data1.bestTimeToCall?.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        data1.bestTimeToCall?.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    if (name == "contactPreference") {
      if (
        data1.contactPreference.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        data1.contactPreference.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    await setData({ ...Data, [name]: multipleValues });
  };
  const handleDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.label
      : event.label || event.value;
    setData({ ...Data, [name]: value });
  };
  const handleOtherDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    if (name === "gender") {
      setData({ ...Data, [name]: value, sex: value });
      return;
    }
    if (name === "county") {
      // let filtered = props?.zipCodes.filter(
      //   (data1) => data1.countyName === value
      // );

      // setData({
      //   ...Data,
      //   [name]: filtered[0]?.countyName,
      //   countyCode:filtered[0]?.countyCode,
      //   state: filtered[0]?.stateCd,
      //   city: filtered[0]?.cityName,
      // });
      let filteredCity1 = [];
         filteredCity1 = props.cityList.filter(
              (city) => city.countyName.trim() ===value?.trim()
            );
            setfilteredCity(filteredCity1)
       
          if (filteredCity1?.length >= 1) {
            setData({
                ...Data,
                [name]:filteredCity1[0]?.countyName,
                countyCode:filteredCity1[0]?.countyCode,
                city: filteredCity1[0].cityName,
                state: filteredCity1[0]?.stateCode,
              });
           
          }
        
      return;
    } else {
      setData({ ...Data, [name]: value });
    }
    setData({ ...Data, [name]: value });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
  };
  const handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      setDates(fieldId, e.target.value);
    });
  };
  const setDates = async (fieldId, value) => {
    if (fieldId === "dob") {
      setData({ ...Data, [fieldId]: value, birthDate: value });
      return;
    }
    setData({ ...Data, [fieldId]: value });
  };
  const handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    if (value === "") {
      setsnackBarOpen(true);
      setalertMsg("Please enter date in the MM/DD/YYYY format");
      setseverity("error");
    }
    if (name === "dob") {
      setData({ ...Data, [name]: value, birthDate: value });
      return;
    }
    setData({ ...Data, [name]: value });
  };
  const save = async (event) => {
    if (SelectedTab === "prospect") {
      let list=["Open","Hold"]
      if (
        Data.firstName === "" ||
        Data.lastName === "" ||
        Data.dob === "" ||
        Data.dob.length < 10 ||
        Data.gender === "" ||
        Data.preferredLang === "" ||
        Data.planCampaignName === "" ||
        Data.permissionToContact === "" ||
        Data.planType?.length < 1 ||
        Data.statusType === "" || (Data.statusType && (!list.includes(Data.statusType)))|| 
        Data.assignedTo === ""
      ) {
        setsnackBarOpen(true);
        setalertMsg("Please Enter All The Mandatory Fields!");
        setseverity("warning");
        return;
      } else {
        setData({ ...Data, saveProspect: true });
        setsnackBarOpen(true);
                  setalertMsg("Prospect saved successfully");
                  setseverity("success");
        setSelectedTab("demographics");
        let prospectPayload = UpdatedList;
        //checking whether already updated row data is updated and that is removed to avoid duplicate rows
        let filtered = {};

        if (prospectPayload?.length > 0) {
          filtered = prospectPayload.filter(
            (obj) => obj.identifier == Data?.identifier
          )[0];
          prospectPayload = prospectPayload.filter(
            (obj) => obj.identifier != Data?.identifier
          );
        }

        //current row values pushing
        prospectPayload.push({ ...filtered, ...Data, saveProspect: true });
        prospectPayload.sort(function (a, b) {
          return a.identifier - b.identifier;
        });

        setUpdatedList(prospectPayload);
      }
    }
    if (SelectedTab === "demographics") {
      if (!Data?.saveProspect) {
        setsnackBarOpen(true);
        setalertMsg("Please fill and save Prospect first");
        setseverity("error");
      } else {
        if (
          (Data?.homePhone?.length === 14 || Data?.homePhone?.length === 0) &&
          (Data?.cellPhone?.length === 14 || Data?.cellPhone?.length === 0)
        ) {
          if (validator.check(Data?.emailAddress, "email") === true) {
            if (validZip === true) {
              if (
                Data?.primaryAddress1 === "" ||
                Data?.city === "" ||
                Data?.state === "" ||
                Data?.zip?.length < 5 ||
                Data?.county?.trim() === "" ||
                (Data?.contactPreference.includes("E")
                  ? Data?.emailAddress?.length > 0
                    ? false
                    : true
                  : false) ||
                (Data?.contactPreference.includes("H")
                  ? Data?.homePhone?.length >= 14
                    ? false
                    : true
                  : false) ||
                (Data?.contactPreference.includes("C")
                  ? Data?.cellPhone?.length >= 14
                    ? false
                    : true
                  : false)
              ) {
                setsnackBarOpen(true);
                setalertMsg("Please Enter All The Mandatory Fields!");
                setseverity("error");
                return;
              } else {
                if (Data?.cellPhone === "" || Data?.cellPhone?.length === 14) {
                  setData({ ...Data, saveDemographics: true });
                  let demographicsPayload = UpdatedList;
                  //checking whether already updated row data is updated and that is removed to avoid duplicate rows
                  let filtered = {};
                  if (demographicsPayload?.length > 0) {
                    filtered = demographicsPayload.filter(
                      (obj) => obj.identifier == Data?.identifier
                    )[0];
                    demographicsPayload = demographicsPayload.filter(
                      (obj) => obj.identifier != Data?.identifier
                    );
                  }

                  //current row values pushing
                  demographicsPayload.push({
                    ...filtered,
                    ...Data,
                    saveProspect: true,
                    saveDemographics: true,
                  });
                  setsnackBarOpen(true);
                  setalertMsg("Prospect and Demographics saved successfully");
                  setseverity("success");
                  demographicsPayload.sort(function (a, b) {
                    return a.identifier - b.identifier;
                  });
                  setUpdatedList(demographicsPayload);
                } else {
                  setsnackBarOpen(true);
                  setalertMsg("Please Enter 10-digit phone number");
                  setseverity("error");
                }
              }
            } else {
              setsnackBarOpen(true);
              setalertMsg("Please Enter Valid Zipcode!");
              setseverity("warning");
              return;
            }
          } else {
            setsnackBarOpen(true);
            setalertMsg("Please Enter Valid Email!");
            setseverity("warning");
          }
        } else {
          setsnackBarOpen(true);
          setalertMsg("Please 10-digit phone number");
          setseverity("warning");
        }
      }
    }
  };
  const Update = async (event) => {
    //list with both prospect and demographics saved
    let UpdatedListFinal = UpdatedList?.length>0 && UpdatedList.filter(
      (data) => data.saveProspect === true && data.saveDemographics === true
    );
    let recordsUpdatedNumber=UpdatedListFinal?.length
    let prospectDataList = [];
    if (UpdatedListFinal?.length > 0) {
      for (const obj of UpdatedListFinal) {
        prospectDataList.push({
          uploadDetailId: obj?.uploadDetailId,
          firstName: obj?.firstName,
          middleInitial: obj?.middleInitial,
          lastName: obj?.lastName,
          mbiNumber: obj?.mbiNumber,
          eligibleForPartA: obj?.eligibleForPartA,
          eligibleForPartB: obj?.eligibleForPartB,
          eligibleForPartD: obj?.eligibleForPartD,
          birthDate: obj?.birthDate,
          sex: obj?.sex,
          preferredLang: obj?.preferredLang,
          permissionToContact: obj?.permissionToContact,
          planType: obj?.planType.toString(),
          statusType: obj?.statusType,
          primaryAddress1: obj?.primaryAddress1,
          primaryAddress2: obj?.primaryAddress2,
          city: obj?.city,
          state: obj?.state,
          zipCode: obj?.zipCode,
          zipPlus4: obj?.zipPlus4,
          // county: props.zipCodes?.filter(
          //   (countyCd) => countyCd?.countyName === obj?.county
          // )[0].countyCode,
          county:obj?.countyCode,
          contactPreference: obj?.contactPreference,
          emailAddr: obj?.emailAddr,
          homePhone: obj?.homePhone,
          cellPhone: obj?.cellPhone,
          bestTimeToCall: obj?.bestTimeToCall,
        });
      }
      let Updatepayload = {
        uploadFileId: props?.SelectedFileId,
        customerId: customerId,
        prospectDataList: prospectDataList,
        status: props?.selectedFilestatus,
      };
      let response = dispatch(updateProspectFilerecords(Updatepayload));

      response.then(function (value) {
        if (value?.status === "OK") {
          setsnackBarOpen(true);
          setalertMsg(`Records updated:${recordsUpdatedNumber}`);
          setseverity("success");
          dispatch(
            prospectFileData({
              fileId: props?.SelectedFileId,
              status: props?.selectedFilestatus,
            })
          );
          dispatch(loadProspectFilesData());
        } else {
          setsnackBarOpen(true);
          setalertMsg("Failed to update");
          setseverity("warning");
        }
      });
    } else {
      setsnackBarOpen(true);
      setalertMsg("Please update both prospect and demographics");
      setseverity("warning");
    }
  };
  const formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  const validator = new SimpleReactValidator();
  return (
    <React.Fragment>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {alertMsg}
        </Alert>
      </Snackbar>
      <div class="container-campaignmain prospecttablealign mt-3 mb-3">
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-dashboard-active ml-5 hcampaign btn-dashboard-active-color "
            onClick={props?.goBack}
          >
            <Text id="plan.goback" />
          </button>
          <button
            class="btn btn-dashboard-active ml-5 hcampaign btn-dashboard-active-color "
            onClick={Update}
          >
            <Text id="app.update" />
          </button>
        </div>
        <div class="ml-3">
          <div class="row">
            <p class="text-nowrap">
              <Text id="app.filename" />
              :&nbsp;
              <strong>{props?.selectedFile}</strong>
            </p>
          </div>
          <div class="row">
            <p>
              <Text id="app.status" />
              :&nbsp;
              <strong>{props?.selectedFilestatus}</strong>
            </p>
          </div>
        </div>
        {/* datatable */}
        <div class="pt-1" style={{ overflow: "auto" }}>
          <DataTable
            modalSelect={"#prospectBulkUploadModal"}
            width="100%"
            //padding="4px 45px 4px 8px"
            padding="4px 20px 4px 4px"
            paddingRight="50px"
            dashboard="BulkUploadSelectedFileData"
            rowsPerPage={bulkmodalrowsPerPage}
            rowsPerPageOptions={[5, 10, 15]}
            handleChangeRowsPerPage={bulkModalhandleChangeRowsPerPage}
            clicked={rowSelectbulkModal}
            //columnSelected={columnSelected}
            setClick={(x) => {}}
            index={bulkmodalselectedRowIndex}
            sortable={true}
            searchable={true}
            header={ProspectSelectedFileHeader}
            rowcount={props?.rowcount}
            //data={props?.newAddUsers}
            data={UpdatedList}
            exportAsExcel={true}
            // clickedFirst={this.prospectrowSelectFirst}
          />
        </div>
        {/* popup */}
        <div
          data-keyboard="false"
          data-backdrop="static"
          id="prospectBulkUploadModal"
          class="modal fade z-index-1051"
        >
          <div
            class={
              "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable "
            }
          >
            <div class="modal-content">
              <div class="modal-header modal-headerprospect">
                <div class="tab-wrapper ml-1">
                  <ul class="nav list">
                    <li class="position-relative">
                      <a
                        href="#prospect"
                        data-toggle="tab"
                        class={
                          SelectedTab === "prospect"
                            ? "nav-link-active prospectfont"
                            : "nav-link-normal prospectfont"
                        }
                        onClick={prospectTab}
                      >
                        Prospect
                      </a>
                    </li>
                    <li class="position-relative">
                      <a
                        href={
                          SelectedTab === "demographics"
                            ? "#demographics"
                            : "#/"
                        }
                        data-toggle="tab"
                        class={
                          SelectedTab === "demographics"
                            ? "nav-link-active prospectfont"
                            : "nav-link-normal prospectfont"
                        }
                        onClick={demographicsTab}
                      >
                        Demographics
                      </a>
                    </li>
                  </ul>
                </div>

                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  // onClick={this.modalSaveClose}
                >
                  &times;
                </button>
              </div>

              <div
                class="modal-body prospect-x-scroll"
                //key={this.state.key}
              >
                <div class="row tab-content prospect-tab tab-contentSharp">
                  <div
                    class={
                      SelectedTab === "prospect"
                        ? "tab-content-login111 tab-pane fade active show"
                        : "tab-content-login111 tab-pane fade"
                    }
                    id="prospect"
                  >
                    <Prospect
                      data={Data}
                      handleChange={handleChange}
                      handleDropdown={handleDropdown}
                      handleOtherDropdown={handleOtherDropdown}
                      handleDates={handleDates}
                      handleDate={handleDate}
                      // mandatoryMbi={this.state.mandatoryMbi}
                      newProspect={true}
                      handleMultipleSelectionDropdown={
                        handleMultipleSelectionDropdown
                      }
                    />
                  </div>

                  <>
                    <div
                      class={
                        SelectedTab === "demographics"
                          ? "tab-content-login111 tab-pane fade active show"
                          : "tab-content-login111 tab-pane fade"
                      }
                      id="demographics"
                    >
                      <Demographics
                        validator={validator}
                        validZip={validZip}
                        data={Data}
                        handleChange={handleChange}
                        handleOtherDropdown={handleOtherDropdown}
                        filteredCity={filteredCity}
                        handleMultipleSelectionDropdown={
                          handleMultipleSelectionDropdown
                        }
                      />
                    </div>
                  </>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  id="submit"
                  onClick={save}
                  class="btn btn-dashboard-active"
                >
                  {" "}
                  {SelectedTab === "demographics" ? (
                    <Text>Save </Text>
                  ) : (
                    <Text>Save & Next </Text>
                  )}
                </button>
                <button
                  class="btn btn-campaign"
                  data-dismiss="modal"
                  //onClick={this.modalSaveClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    prospectagentList: state.campaignProspect.agentList,
    campaignNames: state.campaignProspect.campaignNamesList,
    zipCodes: state.webApp.zipCodes,
    cityList: state.login.cityList,
  };
};
const mapDispatchToProps = {
  ProspectManagementSaveProspect,
  getCampaignList,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(SelectedFileTable));
